export const updateProgressPercent = (updateProgress, { onDone, onError, donePercentPoints = 100, maxPercentPoints = 100, minLoadAnimationDurationMs = 1000, maxLoadTimeoutMs = Infinity, progressTimeRatio = 0.8, } = {}) => {
    let startTimeMs;
    let prevTimeMs;
    let done = false;
    const percentPointsLimit = Math.max(maxPercentPoints, donePercentPoints);
    // eslint-disable-next-line no-use-before-define -- hoisting for raf cb
    const cancelId = requestAnimationFrame(updatePercent);
    function updatePercent(currTimeMs) {
        if (!startTimeMs) {
            startTimeMs = currTimeMs;
        }
        const elapsedMs = currTimeMs - startTimeMs;
        const progPercentPoints = Math.min(progressTimeRatio * elapsedMs, donePercentPoints);
        if (prevTimeMs !== currTimeMs && progPercentPoints <= percentPointsLimit) {
            updateProgress(Math.floor(progPercentPoints));
        }
        if (progPercentPoints >= donePercentPoints &&
            elapsedMs >= minLoadAnimationDurationMs) {
            done = true;
        }
        if (!done && elapsedMs < minLoadAnimationDurationMs) {
            prevTimeMs = currTimeMs;
            requestAnimationFrame(updatePercent);
        }
        if (done && elapsedMs < maxLoadTimeoutMs) {
            cancelAnimationFrame(cancelId);
            onDone?.();
        }
        if (elapsedMs >= maxLoadTimeoutMs) {
            cancelAnimationFrame(cancelId);
            onError?.();
        }
    }
};
export default updateProgressPercent;
